export default __webpack_public_path__ + "static/column-offset-dark-54952c160e7f95310508a2048616506a.png";